import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../api';
import ReactGA from 'react-ga';
import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { Helmet } from "react-helmet";
import WasteTableHeader from "./waste-table-header";
import WasteTableRow from "./waste-table-row";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";

function mapStateToProps(state) {
    return {

    };
}

class WasteTab extends Component {

    constructor(props){
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(api.getWasteList, [this.props.customerId,this.props.siteKey]),
            wasteContainer: [],
            wasteDestination: [],
            wasteStream:[]
        };
    }

    render() {
       
        return (
            <div className="main-container">
                <Helmet>
                    <title>Inenco Portal | Waste</title>
                </Helmet>
                <Grid padded stackable columns='equal' verticalAlign='middle'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Waste</h2>
                        </Grid.Column>
                    </Grid.Row>


                    <Grid.Row>
                        <Grid.Column>
                            <h2>Waste List</h2>
                        </Grid.Column>
                        
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} name="waste" canExport={true}
                                                     headerComponent={WasteTableHeader} rowComponent={WasteTableRow}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                </Grid>
            </div>
        );
    }

    componentDidMount = () => {
        this.fetchData();
       
            ReactGA.pageview('waste tab');
        
    }

    fetchData = () => {
        return Promise.all([
            api.getWasteSubmissionCountByContainer(this.props.customerId),
            api.getWasteSubmissionCountByDestination(this.props.customerId),
            api.getWasteSubmissionCountByStream(this.props.customerId),
          ])
          .then(([ wasteContainer, wasteDestination, wasteStream])=>
          this.setState({  wasteContainer, wasteDestination, wasteStream })
          )

    }
}

export default connect(
    mapStateToProps,
)(WasteTab);